import API from './api';
import { ApiKeyStatus, CreatedApiKey, User, UserUpdate } from '../types';

export const getCurrentUser = async (): Promise<User> => {
  const response = await API().get('/users/me');
  return response.data;
};

export const updateUser = async (userData: UserUpdate): Promise<User> => {
  const response = await API().put('/users/me', userData);
  return response.data;
};

export const changePassword = async (currentPassword: string, newPassword: string): Promise<void> => {
  await API().put('/users/me/password', { currentPassword, newPassword });
};

export const getApiKeyStatus = async (): Promise<ApiKeyStatus> => {
  const response = await API({ feedbackMode: 'off' }).get('/users/me/api-key');
  return response.data;
};

export const createApiKey = async (): Promise<CreatedApiKey> => {
  const response = await API().post('/users/me/api-key');
  return response.data;
};

export const deleteApiKey = async (): Promise<void> => {
  await API().delete('/users/me/api-key');
};

export const deleteUserApiKey = async (userId: string): Promise<void> => {
  await API().delete(`/users/${userId}/api-key`);
};

export const getUserProfile = async (userId: string): Promise<User> => {
  const response = await API().get(`/users/${userId}`);
  return response.data;
};

// Example of a new user-related function
export const updateUserPreferences = async (preferences: any): Promise<void> => {
  await API().put('/users/me/preferences', preferences);
};
